/**
 * ExtractionParcellePage — « Extraire les données » en plein écran sur téléphone (/parcelles/:parcelId/extraction).
 * Sur ordinateur, le même contenu s'ouvre en panneau à droite de la fiche.
 */
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { COL } from "@/components/fiche/shared";
import ExtractionPanel from "@/components/fiche/ExtractionPanel";
import { useFiche, useFicheQuery } from "@/pages/FicheParcellePage";

export default function ExtractionParcellePage() {
  const { parcelId } = useParams();
  const navigate = useNavigate();
  const query = useFicheQuery();
  const { fiche, loading } = useFiche(parcelId, query); // îlots, brouillons et période (cache hors réseau)
  return (
    <div className="min-h-screen" style={{ background: COL.bg }} data-testid="extraction-parcelle-page">
      <header className="sticky top-safe z-[500] bg-white/95 backdrop-blur border-b px-3 py-2 flex items-center gap-2" style={{ borderColor: COL.line }}>
        <button type="button" onClick={() => navigate(`/parcelles/${encodeURIComponent(parcelId)}/fiche${query ? `?${query}` : ""}`)}
          className="w-11 h-11 -ml-1 flex items-center justify-center rounded-full hover:bg-black/5" aria-label="Retour à la fiche">
          <ArrowLeft className="w-5 h-5" style={{ color: COL.green }} />
        </button>
        <div className="min-w-0">
          <div className="font-mono text-[11px] text-gray-500 truncate">{parcelId}</div>
          <div className="text-base font-bold">Extraire les données</div>
        </div>
      </header>
      <main className="p-4 pb-safe">
        {loading ? <Loader2 className="w-6 h-6 animate-spin mx-auto mt-10" style={{ color: COL.green }} />
          : <ExtractionPanel parcelId={parcelId} fiche={fiche} titre={false} />}
      </main>
    </div>
  );
}
